(function () {
    'use strict';
    angular.module('components.download', [
        'components.auth'
    ]);
})();